import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useRecoilState } from 'recoil';
import atoms from './Atoms';

export default () => {
  const [ statusBar, setStatusbar ] = useRecoilState(atoms.statusBar);
  const closeStatusbar = () => setStatusbar({ ...statusBar, open: false });

  return (
    <Snackbar open={statusBar.open} autoHideDuration={5000} onClose={closeStatusbar}>
      <MuiAlert onClose={closeStatusbar} elevation={6} variant="filled" severity={statusBar.severity}>
        {statusBar.message}
      </MuiAlert>
    </Snackbar>
  );
};
